var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "DialogBase",
    {
      attrs: {
        visible: _vm.visible,
        title: "Chi tiết nhận xét định kỳ",
        size: "lg",
        "show-confirm": false,
        "cancel-text": "Đóng",
        "use-panel": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        cancel: _vm.handleClose,
      },
    },
    [
      _vm.studentData
        ? _c("div", { staticClass: "pev-detail" }, [
            _c("div", { staticClass: "sk-panel" }, [
              _c("div", { staticClass: "sk-panel-head" }, [
                _c("div", { staticClass: "sk-panel-icon" }, [
                  _c("i", { staticClass: "el-icon-user" }),
                ]),
                _c("div", [
                  _c(
                    "p",
                    { staticClass: "sk-panel-title" },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.studentData.studentName) +
                          "\n            "
                      ),
                      !_vm.isStudying
                        ? _c(
                            "el-tag",
                            {
                              staticClass: "ml-2",
                              attrs: { size: "mini", type: "info" },
                            },
                            [_vm._v("Đã chuyển")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c("p", { staticClass: "sk-panel-subtitle" }, [
                    _vm._v(
                      "Năm " +
                        _vm._s(_vm.year) +
                        " — " +
                        _vm._s(_vm.evaluations.length) +
                        " lần nhận xét"
                    ),
                  ]),
                ]),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "pev-detail-content-wrap sk-u-mt-12" },
              [
                _vm.evaluations.length === 0
                  ? _c("div", { staticClass: "pev-detail-empty" }, [
                      _c("i", { staticClass: "el-icon-document" }),
                      _c("span", [_vm._v("Chưa có dữ liệu nhận xét")]),
                    ])
                  : _vm._e(),
                _vm._l(_vm.evaluations, function (item) {
                  return _c(
                    "div",
                    { key: item.uid, staticClass: "pev-detail-card" },
                    [
                      _c("div", { staticClass: "pev-detail-card__header" }, [
                        _c(
                          "div",
                          { staticClass: "flex items-center gap-2" },
                          [
                            _c(
                              "el-tag",
                              { attrs: { size: "mini", type: "info" } },
                              [_vm._v("Lần " + _vm._s(item.periodNumber))]
                            ),
                            _c("span", { staticClass: "pev-detail-date" }, [
                              _vm._v(_vm._s(_vm.formatDate(item.date))),
                            ]),
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  size: "mini",
                                  type: item.approved ? "success" : "warning",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      item.approved ? "Đã duyệt" : "Chờ duyệt"
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "pev-detail-actions" },
                          [
                            !item.approved
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "success",
                                      icon: "el-icon-check",
                                      size: "mini",
                                      plain: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleApprove(item)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              Duyệt\n            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  icon: "el-icon-edit",
                                  size: "mini",
                                  plain: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleEdit(item)
                                  },
                                },
                              },
                              [_vm._v("\n              Sửa\n            ")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "danger",
                                  icon: "el-icon-delete",
                                  size: "mini",
                                  plain: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDelete(item)
                                  },
                                },
                              },
                              [_vm._v("\n              Xoá\n            ")]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "pev-content-card" }, [
                        _c("div", { staticClass: "pev-content-card__header" }, [
                          _c("i", { staticClass: "el-icon-edit-outline" }),
                          _c("span", [
                            _vm._v(
                              "Nội dung nhận xét lần " +
                                _vm._s(item.periodNumber)
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "pev-content-card__body" }, [
                          _vm._v(_vm._s(item.content)),
                        ]),
                      ]),
                      _c("div", { staticClass: "pev-detail-card__meta" }, [
                        _c("span", [
                          _c("i", { staticClass: "el-icon-user" }),
                          _vm._v(" " + _vm._s(item.createdBy)),
                        ]),
                        item.createdDate
                          ? _c("span", [
                              _vm._v(
                                " · " +
                                  _vm._s(_vm.formatDateTime(item.createdDate))
                              ),
                            ])
                          : _vm._e(),
                        item.approved && item.approvedBy
                          ? _c("span", [
                              _vm._v(
                                " · Duyệt bởi: " + _vm._s(item.approvedBy)
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      item.replies && item.replies.length > 0
                        ? _c(
                            "div",
                            { staticClass: "pev-replies" },
                            [
                              _c("p", { staticClass: "pev-replies__title" }, [
                                _c("i", {
                                  staticClass: "el-icon-chat-dot-round",
                                }),
                                _vm._v(
                                  " Phản hồi (" +
                                    _vm._s(item.replies.length) +
                                    ")\n          "
                                ),
                              ]),
                              _vm._l(item.replies, function (reply) {
                                return _c(
                                  "div",
                                  {
                                    key: reply.uid,
                                    staticClass: "pev-reply-item",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "pev-reply-item__meta" },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "pev-reply-item__name",
                                          },
                                          [_vm._v(_vm._s(reply.replierName))]
                                        ),
                                        _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              size: "mini",
                                              type: _vm.roleTagType(reply.role),
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.roleLabel(reply.role))
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "pev-reply-item__date",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatDateTime(
                                                  reply.createdDate
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm.isOwnReply(reply)
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "pev-reply-item__actions",
                                              },
                                              [
                                                _c("el-button", {
                                                  attrs: {
                                                    type: "text",
                                                    size: "mini",
                                                    icon: "el-icon-edit",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.startEditReply(
                                                        item,
                                                        reply
                                                      )
                                                    },
                                                  },
                                                }),
                                                _c("el-button", {
                                                  staticClass:
                                                    "pev-reply-delete",
                                                  attrs: {
                                                    type: "text",
                                                    size: "mini",
                                                    icon: "el-icon-delete",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleDeleteReply(
                                                        item,
                                                        reply
                                                      )
                                                    },
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _vm.editingReplyUid === reply.uid
                                      ? _c(
                                          "div",
                                          { staticClass: "pev-reply-edit" },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                size: "small",
                                                placeholder: "Sửa phản hồi...",
                                                maxlength: "500",
                                                "show-word-limit": "",
                                              },
                                              nativeOn: {
                                                keyup: function ($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  )
                                                    return null
                                                  return _vm.submitEditReply(
                                                    item,
                                                    reply
                                                  )
                                                },
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "append",
                                                    fn: function () {
                                                      return [
                                                        _c("el-button", {
                                                          attrs: {
                                                            icon: "el-icon-check",
                                                            loading:
                                                              _vm.replyLoading ===
                                                              reply.uid,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.submitEditReply(
                                                                item,
                                                                reply
                                                              )
                                                            },
                                                          },
                                                        }),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                              model: {
                                                value: _vm.editReplyContent,
                                                callback: function ($$v) {
                                                  _vm.editReplyContent = $$v
                                                },
                                                expression: "editReplyContent",
                                              },
                                            }),
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "text",
                                                  size: "mini",
                                                },
                                                on: {
                                                  click: _vm.cancelEditReply,
                                                },
                                              },
                                              [_vm._v("Huỷ")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticClass:
                                              "pev-reply-item__content",
                                          },
                                          [_vm._v(_vm._s(reply.content))]
                                        ),
                                  ]
                                )
                              }),
                            ],
                            2
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "pev-add-reply" },
                        [
                          _c("el-input", {
                            attrs: {
                              size: "small",
                              placeholder: "Viết phản hồi...",
                              maxlength: "500",
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                return _vm.handleAddReply(item)
                              },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "append",
                                  fn: function () {
                                    return [
                                      _c("el-button", {
                                        attrs: {
                                          icon: "el-icon-s-promotion",
                                          loading:
                                            _vm.replyLoading === item.uid,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleAddReply(item)
                                          },
                                        },
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                            model: {
                              value: _vm.replyContents[item.uid],
                              callback: function ($$v) {
                                _vm.$set(_vm.replyContents, item.uid, $$v)
                              },
                              expression: "replyContents[item.uid]",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  )
                }),
                _vm.isStudying
                  ? _c(
                      "div",
                      { staticClass: "pev-detail-add" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              plain: "",
                              icon: "el-icon-plus",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.$emit("add-period", _vm.studentData)
                              },
                            },
                          },
                          [_vm._v("\n          Tạo nhận xét lần mới\n        ")]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              2
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }